import AxiosClient from './api'
import END_POINT from './constants'

function getProfile({ userId }) {
  return AxiosClient.get(`${END_POINT.PROFILE_USER}?userId=${userId}`)
    .then((res) => res)
}

export function resendSignUpEmail(payload) {
  return AxiosClient.post(`${END_POINT.RESEND_SIGN_UP_EMAIL}`, { email: payload })
}

export function postSignUp(payload) {
  return AxiosClient.post(`${END_POINT.SIGN_UP}`, payload)
}

export function postSignUpWithInviteRequest(payload) {
  return new Promise((resolve, reject) => {
    AxiosClient.post(`${END_POINT.REGISTER_INVITATION_EXTERNAL}`, payload)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.message)
      })
  })
}

export function postSignUpWithPayment(payload) {
  return new Promise((resolve, reject) => {
    AxiosClient.post(`${END_POINT.REGISTER_PAYMENT_METHOD}`, payload)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.message)
      })
  })
}

export function sendMailResetPassword(condition) {
  return new Promise((resolve, reject) => {
    AxiosClient.post(`${END_POINT.SEND_MAIL_RESET_PASSWORD}`, condition)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.message)
      })
  })
}

export function changePassword(condition) {
  return new Promise((resolve, reject) => {
    AxiosClient.post(`${END_POINT.CHANGE_PASSWORD}`, condition)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.message)
      })
  })
}

export function login(condition) {
  return new Promise((resolve, reject) => {
    AxiosClient.post(`${END_POINT.LOGIN}`, condition)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.message)
      })
  })
}

export function loginSSOGoogle(condition) {
  return new Promise((resolve, reject) => {
    AxiosClient.post(`${END_POINT.LOGIN_SSO_GOOGLE}`, condition)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.message)
      })
  })
}

export function loginSSOMASL(condition) {
  return new Promise((resolve, reject) => {
    AxiosClient.post(`${END_POINT.LOGIN_SSO_MSAL}`, condition)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.message)
      })
  })
}

export function registerEnterprisePlan(condition) {
  return new Promise((resolve, reject) => {
    AxiosClient.post(`${END_POINT.REGISTER_ENTERPRISE}`, condition)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.message)
      })
  })
}

export function signUpVerifyToken({ email, token }) {
  return new Promise((resolve, reject) => {
    AxiosClient.get(`${END_POINT.VERIFY_SIGN_UP_TOKEN}?email=${email}&token=${token}`)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.message)
      })
  })
}

export function verifyInviteCodeRegister({ email, inviteCode }) {
  return new Promise((resolve, reject) => {
    AxiosClient.get(`${END_POINT.VERIFY_INVITE_CODE_REGISTER}/${email}/${inviteCode}`)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.message)
      })
  })
}

export function logout() {
  return new Promise((resolve, reject) => {
    AxiosClient.post(`${END_POINT.LOGOUT}`)
      .then(() => {
        resolve(true)
      })
      .catch((err) => {
        reject(err.message)
      })
  })
}

export {
  getProfile
}
